import { tapJournal } from '../journal/journalSync';
import { api } from './http';

export type ModernizationCostSplit = 'shares' | 'manual' | 'personal';

export type Modernization = {
  id: number;
  description: string;
  performed_by: string;
  performed_at: string;
  cost: number;
  cost_split?: ModernizationCostSplit | null;
  payer_user_id?: number | null;
  payer_ids?: number[];
  payer_shares?: number[];
  created_at?: string;
  created_by?: number | null;
  comment?: string | null;
};

export const getModernizations = () =>
  api.get<Modernization[]>('/modernizations');
export type ModernizationPayload = {
  description: string;
  performed_by: string;
  performed_at: string;
  cost: number;
  cost_split?: ModernizationCostSplit;
  payer_user_id?: number;
  payer_ids?: number[];
  payer_shares?: number[];
  comment?: string;
};

const modernizationParams = ({
  payer_ids,
  payer_shares,
  ...rest
}: ModernizationPayload) => ({
  ...rest,
  ...(payer_ids && payer_ids.length ? { payer_ids: payer_ids.join(',') } : {}),
  ...(payer_shares && payer_shares.length
    ? { payer_shares: payer_shares.join(',') }
    : {}),
});

export const addModernization = (data: ModernizationPayload) =>
  tapJournal(
    api.post<Modernization & { added: boolean }>('/modernizations', null, {
      params: modernizationParams(data),
    })
  );

export const updateModernization = (
  modernizationId: number,
  data: ModernizationPayload
) =>
  tapJournal(
    api.put<Modernization & { updated: boolean }>(
      `/modernizations/${modernizationId}`,
      null,
      { params: modernizationParams(data) }
    )
  );

export const deleteModernization = (modernizationId: number) =>
  tapJournal(
    api.delete<{ deleted: boolean }>(`/modernizations/${modernizationId}`)
  );
